var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 160,
    viewBox: "0 0 100 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7866 12.9311C75.7866 7.72498 70.8877 3.50362 64.8518 3.50362C63.0828 3.49871 61.3336 3.87628 59.724 4.61048C58.4698 3.16325 56.9192 2.00259 55.1775 1.20713C53.4357 0.411677 51.5434 0 49.6287 0C47.714 0 45.8216 0.411677 44.0798 1.20713C42.3381 2.00259 40.7875 3.16325 39.5333 4.61048C37.9234 3.87696 36.1744 3.49943 34.4055 3.50362C28.362 3.50362 23.4707 7.72498 23.4707 12.9311C23.4707 21.3738 32.742 23.786 32.742 31.6792H66.5153C66.5153 23.2364 75.7866 20.9387 75.7866 12.9311Z",
    fill: "#BC4DE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6296 25.0537C39.0534 25.0537 30.4766 26.8323 30.4766 29.0308V44.5804H68.7825V28.9926C68.7825 26.7942 60.1828 25.0537 49.6296 25.0537Z",
    fill: "#BC4DE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7825 44.5415C68.7825 46.74 60.2057 48.5263 49.6296 48.5263C39.0534 48.5263 30.4766 46.74 30.4766 44.5415C30.4766 42.3431 39.0534 40.5645 49.6296 40.5645C60.2057 40.5645 68.7825 42.3431 68.7825 44.5415Z",
    fill: "#4B4B4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47655 35.0156L15.3522 38.6721L22.2503 39.2217L20.6021 45.9469L22.2045 52.6874L15.2988 53.1912L9.39262 56.7942L6.77529 50.382L1.52539 45.8782L6.81344 41.4126L9.47655 35.0156Z",
    fill: "#BC4DE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.598 35.0156L83.7224 38.6721L76.8242 39.2217L78.4801 45.9469L76.87 52.6874L83.7758 53.1912L89.6819 56.7942L92.2916 50.382L97.5491 45.8782L92.2611 41.4126L89.598 35.0156Z",
    fill: "#BC4DE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 130.755L50.0038 159.633L100 130.755V72.9998L50.0038 44.1143L0 72.9998V130.755Z",
    fill: "url(#paint0_linear_1729_152)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1673 118.321V92.6243H27.2207L30.5517 85.8032H40.0751V118.321H33.1673Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2054 118.835C54.5838 118.835 51.6255 117.612 49.3303 115.167C47.0351 112.707 45.8875 109.591 45.8875 105.819V98.26C45.8875 94.4879 47.0351 91.3793 49.3303 88.9342C51.6255 86.4742 54.5838 85.2441 58.2054 85.2441C61.8121 85.2441 64.7556 86.4742 67.0358 88.9342C69.331 91.3793 70.4786 94.4879 70.4786 98.26V105.819C70.4786 109.591 69.331 112.707 67.0358 115.167C64.7556 117.612 61.8121 118.835 58.2054 118.835ZM58.2054 111.992C59.815 111.992 61.1116 111.44 62.0953 110.337C63.0789 109.233 63.5707 107.727 63.5707 105.819V98.26C63.5707 96.3367 63.0789 94.8234 62.0953 93.7201C61.1116 92.6168 59.815 92.0652 58.2054 92.0652C56.5809 92.0652 55.2768 92.6168 54.2932 93.7201C53.3096 94.8234 52.8177 96.3367 52.8177 98.26V105.819C52.8177 107.742 53.3096 109.256 54.2932 110.359C55.2768 111.447 56.5809 111.992 58.2054 111.992Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_152",
    x1: 50,
    y1: 44.1143,
    x2: 50,
    y2: 159.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB4BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF74E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel10);
export default __webpack_public_path__ + "static/media/_level-10.87a50013a9abd338f7cfc5b42a5547cc.svg";
export { ForwardRef as ReactComponent };